import { scrollToId } from "@/lib/scroll";
import { LogoLockup } from "@/components/Logo";
import AudioToggle from "@/components/AudioToggle";
import CrowdPulse from "@/components/CrowdPulse";

const NAV = [
  { label: "THE PREMISE", target: "#premise", testid: "nav-premise" },
  { label: "SITE INDEX", target: "#index", testid: "nav-index" },
  { label: "COLOPHON", target: "#colophon", testid: "nav-colophon" },
];

export default function Header({ telemetryRef }) {
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-[#D4AF37]/15 bg-[#0B0C10]/70 backdrop-blur-md">
      <div className="mx-auto flex max-w-[1680px] items-center justify-between px-5 py-3 lg:px-10">
        <button
          data-testid="header-home-button"
          onClick={() => scrollToId("#top")}
          className="transition-opacity hover:opacity-80"
          aria-label="Aetheria home"
        >
          <LogoLockup />
        </button>

        <nav className="hidden items-center gap-6 md:flex xl:gap-9">
          {NAV.map((n) => (
            <button
              key={n.target}
              data-testid={n.testid}
              onClick={() => scrollToId(n.target)}
              className="group relative font-mono text-[10px] tracking-[0.3em] text-white/55 transition-colors hover:text-[#D4AF37]"
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#D4AF37] transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <div className="flex shrink-0 items-center gap-3 lg:gap-4 xl:gap-5">
          <CrowdPulse />
          <AudioToggle />
          <span
            ref={telemetryRef}
            data-testid="header-telemetry"
            className="hidden whitespace-nowrap font-mono text-[10px] tracking-[0.18em] text-[#38BDF8]/80 xl:block"
          >
            LAT +00.00 · LNG +00.00
          </span>
          <button
            data-testid="header-cta"
            onClick={() => scrollToId("#index")}
            className="whitespace-nowrap rounded-full border border-[#D4AF37]/50 px-4 py-2 font-mono text-[10px] tracking-[0.28em] text-[#D4AF37] transition-all duration-300 hover:bg-[#D4AF37] hover:text-[#0B0C10] xl:px-5"
          >
            EXPLORE
          </button>
        </div>
      </div>
    </header>
  );
}
